module.exports = __webpack_public_path__ + "media/POL_BF_60_4K_11242021_FINAL_Compressed.6a9821ab.mp4";